export default __webpack_public_path__ + "static/media/self-delivery-area-setup.96547011.png";